export enum MerchantStatus {
  New = 'New',
  Approved = 'Approved',
  Setup = 'Setup',
  Active = 'Active',
  Disabled = 'Disabled',
}
